export default __webpack_public_path__ + "static/info-messages-flag-b28db93d7a5c4304458b23c66b63292508e229524b8079d73915eb26a60c9036.png";